export default __webpack_public_path__ + "static/media/ARTIST-14 (1-2).91569f2a.jpg";